<template>
    <div class="alert alert-danger" v-if="errorMessage" v-html="errorMessage"></div>
</template>

<script>
    export default {
        props: { 
            error: {
                default: "none"
            },
        },
        computed: {
            errorMessage() {
                let err = this.error;

                if (err == "none" && this.$parent.error) err = this.$parent.error;

                if (!err) return null;
                
                if (_.isString(err)) {
                    return err;
                } else if (err.message) {
                    return err.message;
                } else {
                    return JSON.stringify(err);
                }
            }
        }
    }

</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/framework/primitives/ErrorMessage.vue